import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const HeroContainer = styled.div.attrs({
  className: 'bg-white mx-auto my-0 relative w-full'
})`
  max-width: 1800px;
  min-height: 200px;

  @media (min-width: ${legacyBreakpoints.m}px) {
    min-height: 400px;
  }

  @media (min-width: ${legacyBreakpoints.l}px) {
    min-height: 500px;
  }

  .spinner-tour-lock-body & {
    z-index: 9999;
  }
`;
